<template>
  <div class="animated fadeIn" @keyup.enter="onFilter">
    <div class="form-group row">
      <div class="col-md-12">
        <label> CPF/CNPJ:</label>
        <div class="input-group">
          <b-form-input type="text"
                        :placeholder="'Digite o CPF ou CNPJ'"
                        v-model="form.document.value"
                        :state="form.document.state"
                        autofocus
          />
        </div>
      </div>
    </div>
    <div class="form-group row pt-2">
      <div class="col-md-12">
        <label> Nome:</label>
        <div class="input-group">
          <b-form-input type="text"
                        :placeholder="'Digite o nome'"
                        v-model="form.nome.value"
                        :state="form.nome.state"
          />
        </div>
      </div>
    </div>
    <div class="form-group row pt-2">
      <div class="col-md-12">
        <label> Gerente:</label>
        <div class="input-group">
          <v-select
            multiple
            v-model="employee.selected"
            :options="employee.listOptions"
            class="w-100"
            label="text"
          >
            <template v-slot:no-options>Nenhum Gerente encontrado.</template>
          </v-select>
        </div>
      </div>
    </div>
    <div class="form-group row pt-2">
      <div class="col-md-12">
        <label> Responsáveis:</label>
        <div class="input-group">
          <v-select
            multiple
            v-model="responsible.selected"
            :options="responsible.listOptions"
            class="w-100"
            label="text"
          >
            <template v-slot:no-options>Nenhum Reponsável encontrado.</template>
          </v-select>
        </div>
      </div>
    </div>
    <div class="form-group row pt-2">
      <div class="col-md-12">
        <label> Usuário Alteração:</label>
        <div class="input-group">
          <v-select
            multiple
            v-model="user.selected"
            :options="user.listOptions"
            class="w-100"
            label="text"
          >
            <template v-slot:no-options>Nenhum Usuário encontrado.</template>
          </v-select>
        </div>
      </div>
    </div>
    <div class="form-group row pt-2">
      <div class="col-md-12">
        <label> Produtos:</label>
        <div class="input-group">
          <v-select multiple v-model="product.selected" :options="product.listOptions" placeholder="Selecione o produto"
            class="w-100" label="text">
            <template v-slot:no-options>Nenhum produto encontrado.</template>
          </v-select>
        </div>
      </div>
    </div>
    <div class="form-group row pt-2">
      <div class="col-md-12">
          <label>Data Mínima:</label>
          <NxDatePicker
            :placeholder="$lang.Common.DatePlaceholder"
            v-model="form.dataSituacaoInicial.value"
            :maxlength="form.dataSituacaoInicial.maxlength"
            :required="form.dataSituacaoInicial.required"
            :state="form.dataSituacaoInicial.state"
          />
        </div>
    </div>
    <div class="form-group row pt-2">
      <div class="col-md-12">
          <label>Data Máxima:</label>
          <NxDatePicker
            :placeholder="$lang.Common.DatePlaceholder"
            v-model="form.dataSituacaoFinal.value"
            :maxlength="form.dataSituacaoFinal.maxlength"
            :required="form.dataSituacaoFinal.required"
            :state="form.dataSituacaoFinal.state"
          />
        </div>
    </div>

    <div class="form-group row pt-3">
      <div class="col-md-12 pt-2">
        <button
          type="button"
          class="btn btn-third w-100"
          v-on:click="onFilter"
        >
          Filtrar
        </button>
      </div>
      <div class="col-md-12 pt-2">
        <button
          type="button"
          class="btn btn-default w-100"
          v-on:click="onClearFilters"
        >
          Limpar Filtros
        </button>
      </div>
    </div>
    <div class="form-group row" style="margin-top: 250px;">&nbsp;<!--Space to scroll--></div>
  </div>
</template>

<script>
import CardSearch from './search.js'
export default CardSearch
</script>



// WEBPACK FOOTER //
// src/views/private/crm/card/search/search.vue